import React from "react";
import { BuildingTable } from "../../../buildings/components/BuildingTable/BuildingTable";
import { BuildingFilter } from "../../../buildings/components/BuildingFilter/BuildingFilter";
import { EditBuildingModal } from "../../../buildings/components/EditBuildingModal/EditBuildingModal";
import { CreateBuildingModal } from "../../../buildings/components/CreateBuildingModal/CreateBuildingModal";
import { useBuildingsTab } from "./useBuildingsTab";
import { ResourceTab } from "../../../../shared/components/layout/ResourceTab";
import { ActionButton } from "../../../../shared/components/layout/ActionButton";

export const BuildingsTab: React.FC<ReturnType<typeof useBuildingsTab>> = (props) => {
  const {
    buildingsResource,
    selectedBuilding,
    handleEditBuilding,
    handleCloseEditModal,
    handleUpdateBuilding,
    handleOpenCreateModal,
    isUpdating,
    statusOptions,
    cityOptions,
    defaultValues,
    handleCloseCreateModal,
    handleCreateBuilding,
    isCreateModalOpen,
    isCreating,
    activeBuildingsCount,
  } = props;

  return (
    <ResourceTab
      resource={{
        data: buildingsResource.data,
        isLoading: buildingsResource.isLoading,
        isError: buildingsResource.isError,
        page: buildingsResource.page,
        pageSize: buildingsResource.pageSize,
        handlePageChange: buildingsResource.handlePageChange,
        handlePageSizeChange: buildingsResource.handlePageSizeChange,
      }}
      filtersComponent={
        <BuildingFilter
          name={buildingsResource.filters.name}
          cityId={buildingsResource.filters.city_id}
          cityOptions={cityOptions}
          onNameChange={(v) => buildingsResource.handleFilterChange("name", v)}
          onCityChange={(v) => buildingsResource.handleFilterChange("city_id", v)}
          onClearFilters={buildingsResource.resetFilters}
        />
      }
      tableComponent={
        <BuildingTable
          buildings={buildingsResource.data!}
          isLoading={buildingsResource.isLoading}
          isError={buildingsResource.isError}
          page={buildingsResource.page}
          pageSize={buildingsResource.pageSize}
          onPageChange={buildingsResource.handlePageChange}
          onPageSizeChange={buildingsResource.handlePageSizeChange}
          onEditBuilding={handleEditBuilding}
          activeBuildingsCount={activeBuildingsCount}
        />
      }
      headerAction={
        <ActionButton onClick={handleOpenCreateModal} label="Nuevo" />
      }
      emptyStateMessage="No hay unidades residenciales para mostrar."
      editModal={
        selectedBuilding ? (
          <EditBuildingModal
            open={!!selectedBuilding}
            onClose={handleCloseEditModal}
            defaultValues={defaultValues}
            onSubmit={handleUpdateBuilding}
            isSubmitting={isUpdating}
            cityOptions={cityOptions}
            statusOptions={statusOptions}
          />
        ) : undefined
      }
      createModal={
        <CreateBuildingModal
          open={isCreateModalOpen}
          onClose={handleCloseCreateModal}
          defaultValues={{ name: "", city_id: "" }}
          onSubmit={handleCreateBuilding}
          isSubmitting={isCreating}
          cityOptions={cityOptions}
        />
      }
    />
  );
};
